import { useGradientLiveBorder } from './useGradientLiveBorder';
import React from 'react';

export interface GradientLiveBorderProps {
  paused?: boolean;
  children?: React.ReactNode;
}

export function GradientLiveBorder(props: GradientLiveBorderProps) {
  const { paused, children } = props;
  const { onAnimationIteration, containerClassName, className } =
    useGradientLiveBorder({
      paused,
    });
  return (
    <div className={containerClassName}>
      <div className={className} onAnimationIteration={onAnimationIteration}>
        {children}
      </div>
    </div>
  );
}
